import type { Module } from 'vuex';

export interface BreadcrumbItem {
    title?: string;
    text: string;
    name?: string;
    action?: string;
    disabled?: boolean;
    noTranslate?: boolean;
    to?: string | object;
    href?: string;
}

export interface BreadcrumbState {
    breadcrumbs: BreadcrumbItem[];
    display?: boolean;
}

const breadcrumbStore: Module<BreadcrumbState, unknown> = {
    state: {
        breadcrumbs: [],
        display: true,
    },
    mutations: {
        set(state: BreadcrumbState, breadcrumbs: BreadcrumbItem[]) {
            state.breadcrumbs = breadcrumbs;
        },
        push(state: BreadcrumbState, route: BreadcrumbItem) {
            const index = state.breadcrumbs.findIndex(
                (breadcrumb) => breadcrumb.name === route.name && breadcrumb.text === route.text,
            );
            if (index === -1) {
                state.breadcrumbs.push(route);
            }
        },
        pop(state: BreadcrumbState) {
            state.breadcrumbs.pop();
        },
        empty(state: BreadcrumbState) {
            state.breadcrumbs = [];
        },
        display(state: BreadcrumbState, display: boolean) {
            state.display = display;
        },
    },
    actions: {
        setBreadcrumbs({ commit }, breadcrumbs: BreadcrumbItem[]) {
            commit('set', breadcrumbs);
        },
        pushBreadcrumb({ commit }, route: BreadcrumbItem) {
            commit('push', route);
            commit('display', true);
        },
        popBreadcrumb({ commit }) {
            commit('pop');
        },
        emptyBreadcrumbs({ commit }) {
            commit('empty');
        },
        displayBreadcrumb({ commit }, display: boolean) {
            commit('display', display);
        },
    },
    getters: {
        breadcrumbs: (state: BreadcrumbState): BreadcrumbItem[] => state.breadcrumbs,
        displayBreadcrumb: (state: BreadcrumbState): boolean => state.display ?? true,
    },
};

export default breadcrumbStore;
